
export default () => '9 9 9  9 9 9'
